var userLanguage = localStorage.getItem("i18nextLng").substr(0,2) || null
var browserLanguage = navigator.language || navigator.userLanguage;

export default {
    currentLanguage: userLanguage || browserLanguage,
    account: {
        roles: []
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js